import React from 'react'
import { useSelector } from 'react-redux'
import UserInfoCol from '../user-info-col/user-info-col.component';
import LeaderboardChart from './leaderboard-chart.component';

const UserDataDisplay = ({
  leaders,
  matchups
}) => {

  const userProfile = useSelector(state => state.userData.profile);

  return (
    <div className='user-data-display'>
      <UserInfoCol
            leaders={leaders}
            matchups={matchups}
            userId={userProfile?.appId}
          />

      <div className="g-space-1"></div>
      {/* <LeaderboardChart 
        matchups={matchups} /> */}
    </div>
  )
}

export default UserDataDisplay